/**
 * UNE QUANTITÉ LUE DANS UNE CELLULE DE FICHIER (import d'articles) — des pièces entières, ou `null` si elle n'est pas
 * lisible.
 * ⚠️ UNE SEULE RÈGLE POUR L'ÉCRAN ET LE SERVEUR : l'écran juge avant l'envoi, le serveur écrit — l'écran refusait
 *    « 1 000 », que le serveur acceptait.
 * ⚠️ PAS DE DÉCIMALE : le grand livre compte des pièces, et « 2,5 » est une colonne qui ne dit pas ce qu'on croit.
 */
export function parseCellQuantity(raw: string): number | null {
  const t = raw.replace(/[\s\u00a0\u202f]/g, '');
  return /^\d+$/.test(t) ? Number(t) : null;
}
